import client from "@https/api";
import clientV2 from "@https/api-v2";
import {
  IHomeHowToLearn,
  IHowToLearnLandingData,
} from "@features/home/helpers/types";
import gate from "gate/gate";
import {
  IHowToLearnDetailInput,
  IHowToLearnDetailProduct,
  IHowToLearnDetailProductV2,
  IHowToLearnInput,
} from "../types";

const howToLearnApi = {
  singleHowToLearn: (
    slug: String,
    params?: {
      recache: 1;
    }
  ) =>
    gate.get<
      IHowToLearnDetailInput,
      never,
      {
        recache: 1;
      }
    >({
      client,
      url: `/landings/${slug}`,
      params,
    }),
  singleHowToLearnProduct: (
    slug: String,
    params?: {
      page: number;
      limit: number;
      recache?: 1;
    }
  ) =>
    gate.get<
      IHowToLearnDetailProduct,
      never,
      {
        page: number;
        limit: number;
      }
    >({
      client,
      url: `/landings/${slug}/products`,
      params,
    }),
  singleHowToLearnProductV2: (
    slug: String,
    params?: {
      page: number;
      limit: number;
      recache?: 1;
      sort?: "recommended" | "sold_rate" | "view_rate" | "newest";
    }
  ) =>
    gate.get<
      IHowToLearnDetailProductV2,
      never,
      {
        page: number;
        limit: number;
      }
    >({
      client: clientV2,
      url: `/landings/${slug}/products`,
      params,
    }),
  singleHowToLearnRelated: (slug: String) =>
    gate.get<IHomeHowToLearn<IHowToLearnLandingData[]>, never, never>({
      client,
      url: `/landings/${slug}/relatedLandings`,
    }),
  everything: (params: { page: number; limit: number }) =>
    gate.get<IHowToLearnInput, never, { page: number; limit: number }>({
      client,
      params: params,
      url: `/landings`,
    }),
};

export default howToLearnApi;
